<span [class]="badgeClasses() + ' ' + (styleClass() || '')">
  @if (dot()) {
    <span [class]="dotClasses()"></span>
  }
  @if (icon(); as i) {
    <ui-icon [name]="i" size="xs"></ui-icon>
  }
  @if (displayText(); as dt) {
    {{ dt }}
  }
  <ng-content></ng-content>
  @if (removable()) {
    <button type="button" [class]="removeButtonClasses" aria-label="Remove">
      <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
      </svg>
    </button>
  }
</span>
